export class ProjectGroupRoleDto {
    id!: string;
    name!: string;
    projectId!: string;
    permissions!:string;
    groupRoleId!:string;
    isforadmin!:boolean;
}

export class ProjectGroupRoleForCreationDto {
    id!: string;
    name!: string;
    projectId!: string;
    permissions!: string;
    groupRoleId!:string;
    isforadmin!:boolean;
}